export default __webpack_public_path__ + "static/ai-agent-workflow-optimization-db05bcf3163d1cded226c21c3ec4b2ae.jpg";